export default {
  MINUS_BUTTON: "Уменьшить",
  PLUS_BUTTON: "Увеличить",
  GEO_BUTTON: "Вернуться к маршруту",
};
